import script from "./StaffDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./StaffDropdownMenu.vue?vue&type=style&index=0&id=59faa051&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59faa051"]])

export default __exports__